/*SYSTEM IMPORTS*/
    import React from 'react'

    import Link from 'components/Link'

/* EXTERNALS */
    import { Breadcrumb as BootstrapBreadcrumb } from 'react-bootstrap'

const BreadcrumbItem = ({ children, active, to }) => (
    active ? (
        <li className="breadcrumb-item active">
            <span className="active">
                {children}
            </span>
        </li>
    ) : (
        <li className="breadcrumb-item">
            <Link to={to}>
                {children}
            </Link>
        </li>
    )
)

const Breadcrumb = props => (
    <BootstrapBreadcrumb>
        <BreadcrumbItem key="main" to="/" active={props.list.length === 0}>
            Главная
        </BreadcrumbItem>
        
        { props.list.map(( item, index ) => (
            <BreadcrumbItem key={index} to="/" active={item.active || index === props.list.length -1} to={item.link}>
                {item.title}
            </BreadcrumbItem>
        )) }
    </BootstrapBreadcrumb>
)

export default Breadcrumb